import { render, staticRenderFns } from "./coa-addnew.vue?vue&type=template&id=e3cff836"
import script from "./coa-addnew.vue?vue&type=script&lang=js"
export * from "./coa-addnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports